import React, { useState, useRef, useEffect, useLayoutEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../../../context/CartContext';
import { useAuth } from '../../../context/AuthContext';

const SiteNavBar = () => {
  const { cart } = useCart();
  const { isAuthenticated } = useAuth();
  const navMountRef = useRef(null);

  // MeanMenu injects the mobile hamburger into .mobile-menu below meanScreenWidth.
  // useLayoutEffect + sync init: setTimeout(..., 0) lets two MeanMenu inits overlap
  // (Strict Mode, navigation) so two .mean-bars flash until a full refresh replays
  // a single clean sequence. Layout effect runs before paint with synchronous cleanup.
  useLayoutEffect(() => {
    let rafId = 0;
    const $ = window.jQuery;
    if (!$?.fn?.meanmenu || !navMountRef.current) {
      return undefined;
    }

    $(window).off('resize.meanmenuFMS');

    const $root = $(navMountRef.current);
    const $mainMenu = $root.find('nav.main-menu');
    const $mobileMenu = $root.find('.mobile-menu');
    if (!$mainMenu.length || !$mobileMenu.length) {
      return undefined;
    }

    $root.find('.mean-bar').remove();
    $root.find('.mean-push').remove();
    $mobileMenu.removeClass('mean-container');
    $mainMenu.removeAttr('style').css('display', '');

    $mainMenu.meanmenu({
      meanMenuContainer: $mobileMenu,
      meanScreenWidth: '992',
    });

    // Sticky plugin (main.js) sets .sticky-wrapper height from #sticker outerHeight() on
    // scroll only. Opening MeanMenu grows the header; closing it does not fire scroll, so
    // the wrapper keeps the tall height → large empty nav-colored band. Re-sync on toggle.
    const syncStickyWrapperHeight = () => {
      if (window.jQuery?.fn?.sticky && window.jQuery('#sticker').length) {
        window.jQuery('#sticker').sticky('update');
      }
    };
    const onMeanMenuToggle = () => {
      syncStickyWrapperHeight();
      window.requestAnimationFrame(syncStickyWrapperHeight);
      window.setTimeout(syncStickyWrapperHeight, 320);
    };
    $root.on('click.meanmenuStickyHeight', '.meanmenu-reveal', onMeanMenuToggle);
    $(window).on('resize.meanmenuStickyHeight', syncStickyWrapperHeight);

    const stripExtraBars = () => {
      if (!navMountRef.current) return;
      $(navMountRef.current).find('.mobile-menu').children('.mean-bar').slice(1).remove();
    };
    stripExtraBars();
    rafId = window.requestAnimationFrame(stripExtraBars);

    return () => {
      window.cancelAnimationFrame(rafId);

      if (window.jQuery) {
        window.jQuery(window).off('resize.meanmenuFMS');
      }
      if (!$ || !navMountRef.current) return;
      const $cleanupRoot = $(navMountRef.current);
      $cleanupRoot.off('click.meanmenuStickyHeight', '.meanmenu-reveal');
      $(window).off('resize.meanmenuStickyHeight');
      const $cleanupMobile = $cleanupRoot.find('.mobile-menu');
      const $cleanupMain = $cleanupRoot.find('nav.main-menu');
      $cleanupRoot.find('.mean-bar').remove();
      $cleanupRoot.find('.mean-push').remove();
      $cleanupMobile.removeClass('mean-container');
      $cleanupMain.removeAttr('style').css('display', '');
    };
  }, []);

  return (
    // <div style={{width: '100%'}}>
    //   <nav className="App-nav">
    //     <Link to="/">Home</Link>
    //     <Link to="/shop">Shop</Link>
    //     <Link to="/cart">Cart</Link>
    //   </nav>
    // </div>
    <div ref={navMountRef} id="sticker-sticky-wrapper" className="sticky-wrapper" style={{height: '85px'}}>
      <div className="top-header-area" id="sticker">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-sm-12 text-center" style={{verticalAlign: 'middle'}}>
              <div className="main-menu-wrap">
                {/* logo */}
                <div className="site-logo">
                  <a href="/" aria-label="Farmers Marketspace home">
                    <img src="/images/logo.png" alt="Farmers Marketspace" />
                  </a>
                </div>
                {/* logo */}

                {/* menu start */}
                <nav className="main-menu">
                  <ul>
                    <li><a href="/">Home</a></li>
                    <li><a href="/shop">Shop</a></li>
                    <li><a href="/pickup-location">Pickup Location</a></li>
                    <li><a href="/producers">Producers</a></li>
                    {/* Membership tab temporarily hidden */}
                    {/* <li><a href="/membership">Membership</a></li> */}
                    {/* <li><a href="about.html">About</a></li>
                    <li><a href="contact.html">Contact</a></li> */}
                    <li>
                      <div className="header-icons">
                        <a className="shopping-cart" href="/cart" style={{ position: 'relative' }}>
                          <i className="fas fa-shopping-cart"></i>
                          {cart.length > 0 && (
                            <span style={{
                              position: 'absolute',
                              top: -8,
                              right: -8,
                              background: 'orange',
                              color: 'white',
                              borderRadius: '50%',
                              padding: '2px 7px',
                              fontSize: 12,
                              fontWeight: 'bold',
                              zIndex: 1
                            }}>{cart.length}</span>
                          )}
                        </a>
                        <AccountDropdown />
                      </div>
                    </li>
                  </ul>
                </nav>
                {/* <a className="mobile-show search-bar-icon" href="#"><i className="fas fa-search"></i></a> */}
                <a className="mobile-show search-bar-icon" href={isAuthenticated ? "/account/dashboard" : "/account/signin"}>
                  <i className="fas fa-user"></i>
                </a>
                <div className="mobile-menu"></div>
                {/* menu end */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const dropdownItemStyle = {
  padding: '12px 20px',
  cursor: 'pointer',
  color: '#333',
  borderBottom: '1px solid #eee'
};

const AccountDropdown = () => {
  const [open, setOpen] = useState(false);
  const ref = useRef();
  const navigate = useNavigate();
  const { logout, isAuthenticated } = useAuth();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (tab) => {
    setOpen(false);
    if (tab === 'logout') {
      if (!window.confirm('Are you sure you want to log out?')) {
        return;
      }
      logout();
      navigate('/account/signin');
    } else if (tab === 'login') {
      navigate('/account/signin');
    } else {
      navigate(`/account/dashboard?tab=${tab}`);
    }
  };

  return (
    <div ref={ref} style={{ position: 'relative', display: 'inline-block' }}>
      <button onClick={() => setOpen(!open)} style={{ background: 'none', border: 'none', padding: 0, verticalAlign: 'middle' }}>
        <i className="fas fa-user" style={{ fontSize: 18, color: '#fff', verticalAlign: 'middle' }}></i>
      </button>
      {open && (
        <div style={{
          position: 'absolute', right: 0, top: '100%',
          background: '#fff', boxShadow: '0 2px 8px rgba(0,0,0,0.15)', borderRadius: 6, minWidth: 160, zIndex: 100
        }}>
          {!isAuthenticated ? (
            <div onClick={() => handleSelect('login')} style={dropdownItemStyle}>Login</div>
          ) : (
            <>
              <div onClick={() => handleSelect('profile')} style={dropdownItemStyle}>Profile</div>
              {/* Subscriptions tab temporarily hidden */}
              {/* <div onClick={() => handleSelect('subscriptions')} style={dropdownItemStyle}>Subscriptions</div> */}
              <div onClick={() => handleSelect('orders')} style={dropdownItemStyle}>Orders</div>
              <div onClick={() => handleSelect('logout')} style={dropdownItemStyle}>Logout</div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default SiteNavBar;